

import * as server from "@/utils/http"
export const _getUserList = params => server.getByStreetCode("/sysUser/selectPages",params);
export const _roleUserByPages = params => server.getByStreetCode("/sysUser/roleUserByPages",params);
export const _getUserById = params => server.getByStreetCode("/sysUser/queryUserById?",params);
export const _editUser = params => server.postByStreetCode(params.id ? "/sysUser/update" : "/sysUser/save",params);
export const _updateStatus = params => server.getByStreetCode("/sysUser/updateStatus", params);
export const _delUser = params => server.getByStreetCode("/sysUser/delete?",params);
